// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__IDKaa","containerItemsCenter":"Skeleton_containerItemsCenter__mOrRl"};